module.exports = __webpack_public_path__ + "static/media/ico_info_black.fa92e9bf.svg";